import React, { Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import Layout from "../components/Layout/Layout";
import LoadingPanel from "../components/sys-toolbox/LoadingPanel";

import { GuestEvents } from "../pages/GuestEvent/GuestEvents";
import { GuestEventDetailPage } from "../pages/GuestEvent/GuestEventDetailPage";
import { QrScannerPage } from "../pages/QrScanner/QrScannerPage";
import { AdminRoute } from "./AdminRoute";
import { SuperAdminRoute } from "./SuperAdminRoute";
import { QrScannerRoute } from "./QrScannerRoute";
import { Home } from "../pages/Home/Home";
import { NoMatch } from "../utils/common";
import { Events } from "../pages/Event/Events";
import { EventDetail } from "../pages/Event/EventDetail";
import { Templates } from "../pages/MailTemplate/Templates";
import { CompanyCalendar } from "../pages/Calendar/CompanyCalendar";
import { ParticipantInfo } from "../pages/Participant/ParticipantInfo";
import { CompanySchedulerIntra2 } from "../containers/CompanyCalendar/CompanySchedulerIntra2";
import { TicketPage } from "../pages/Ticket/TicketPage";

const App = () => {
  return (
    <Layout>
      <Suspense fallback={LoadingPanel}>
        <Outlet />
      </Suspense>
    </Layout>
  );
};

/**
 * @type {import("react-router-dom").RouteObject[]}
 */
export const protectedRoutes = [
  // Ticket — giriş yapılmışken de Layout'suz açılmalı
  { path: "/bilet/:token", element: <TicketPage /> },
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: (
          <AdminRoute>
            <Home />
          </AdminRoute>
        ),
      },
      {
        path: "/events",
        element: (
          <AdminRoute>
            <Events />
          </AdminRoute>
        ),
      },
      {
        path: "/event/:id",
        element: (
          <AdminRoute>
            <EventDetail />
          </AdminRoute>
        ),
      },
      {
        path: "/template",
        element: (
          <AdminRoute>
            <Templates />
          </AdminRoute>
        ),
      },
      {
        path: "/calendar",
        element: (
          <AdminRoute>
            <CompanyCalendar />
          </AdminRoute>
        ),
      },
      { path: "/participant/:id", element: <ParticipantInfo /> },
      { path: "/company-calendar-intranet", element: <CompanySchedulerIntra2 /> },
      {
        path: "/guest-events",
        element: (
          <SuperAdminRoute>
            <GuestEvents />
          </SuperAdminRoute>
        ),
      },
      {
        path: "/guest-event/:id",
        element: (
          <SuperAdminRoute>
            <GuestEventDetailPage />
          </SuperAdminRoute>
        ),
      },
      {
        path: "/qr-scanner",
        element: (
          <QrScannerRoute>
            <QrScannerPage />
          </QrScannerRoute>
        ),
      },
      { path: "404", element: <NoMatch /> },
      { path: "*", element: <Navigate to="/404" replace /> },
    ],
  },
];
